/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {getUserByToken, login} from '../core/_requests'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'
import authAPI from '../../../../api/authAPI'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: 'admin@demo.com',
  password: 'demo',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function EmailVerifyWelcomePage() {
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()

  const url = window.location.href
  const parts = url.split('/')
  const token = parts[parts.length - 1]
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem('tempUser') || '{}');
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        let data = {
          token: token,
        }
        authAPI.registerAction(data).then(
          (res: any) => {
            if (res?.data?.success) {
              localStorage.removeItem('tempUser')
              toast.success(res?.data?.message, {theme: 'dark'})
              navigate('/auth/login')
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
              navigate('/auth/registration')
            }
          },
          (err: any) => {
            navigate('/auth/registration')
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      } catch (error) {
        // console.error(error)
        saveAuth(undefined)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <div
      className='d-flex flex-column flex-lg-row flex-column-fluid h-100'
      style={{background: 'white',}}
    >
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-lg-500px d-flex justify-content-center flex-wrap' >
            <img
              src={toAbsoluteUrl('/media/logos/asteric-white.png')}
              alt='logo'
              height={80}
              className='mb-5'
            />
            <form
              className='form w-100 card p-10'
              onSubmit={formik.handleSubmit}
              noValidate
              id='kt_login_signin_form'
            >
              <img
                style={{
                  height: '150px',
                  width: '114%',
                  marginLeft: '-7%',
                }}
                src={toAbsoluteUrl('/media/custom/welcome.png')}
                alt='logo'
                height={80}
                className='mb-5'
              />

              <hr className='py-3' />
              {/* begin::Login options */}

              {/* begin::Form group */}
              <div
                className='fv-row mb-8'
                style={{
                  fontWeight: '500',
                  fontSize: '14px',
                  lineHeight: '22px',
                  fontFamily: 'Inter',
                }}
              >
                Dear {user?.firstname}, <br />
                <br />
                Welcome to Asterics! We are glad to have you here, before you continue, do one quick
                thing for us. Click the button below to verify your email, you’ll then be able to
                sign in to your account.
              </div>
              {/* end::Form group */}

              {/* begin::Action */}
              <div className='mb-10 d-flex justify-content-center'>
                <button
                  type='submit'
                  id='kt_sign_in_submit'
                  className='btn'
                  style={{background: '#454743', color: '#fff', borderRadius: 50}}
                  disabled={formik.isSubmitting || !formik.isValid}
                >
                  {!loading && <span className='indicator-label'>Verify email</span>}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* end::Action */}

              <div className='text-black-500 text-center fw-semibold fs-6 mt-5'>
                <p>Connect with us: </p>
                <p>
                  <a href=''>
                    <img
                      style={{paddingRight: '5px'}}
                      src={toAbsoluteUrl('/media/custom/social/insta.png')}
                      alt='insta'
                    />
                  </a>

                  <a href=''>
                    <img
                      style={{paddingRight: '5px'}}
                      src={toAbsoluteUrl('/media/custom/social/linkedin.png')}
                      alt='linkedin'
                    />
                  </a>

                  <a href=''>
                    <img src={toAbsoluteUrl('/media/custom/social/twitter.png')} alt='twitter' />
                  </a>
                </p>
                <p className='text-center'>© 2023 Astericsworkspace. All Rights Reserved.</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
